import { intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from '@99designs/common/components/Spinner';
import SpinnerContainer from 'launch/components/SpinnerContainer';

export default function loadRoute(componentLoaded, props = {}) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                component: null,
            };
        }

        static contextTypes = {
            getStore: PropTypes.func,
            executeAction: PropTypes.func,
            intl: intlShape.isRequired,
        };

        componentDidMount() {
            componentLoaded(component => {
                this.setState({
                    component: component.default,
                });
            });
        }

        render() {
            const { component } = this.state;
            if (component) {
                return React.createElement(component, {
                    ...props,
                });
            } else {
                return (
                    <SpinnerContainer>
                        <Spinner variations={['large', 'inline']} />
                    </SpinnerContainer>
                );
            }
        }
    };
}
